module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/essentials-collection-5000273a0b53bc01186da9b3b8ffa72f.png";